import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20haunting%20hospital%20corridor%20at%20midnight%2C%20long%20empty%20hallway%20with%20flickering%20fluorescent%20lights%2C%20abandoned%20gurney%20in%20shadow%2C%20cold%20clinical%20atmosphere%2C%20mist%20on%20floor%2C%20cinematic%20horror%20photography%2C%20deep%20shadows%2C%20eerie%20moody%20lighting%2C%20dark%20red%20exit%20sign%20glow%2C%20no%20people%2C%20atmospheric%20fog&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
        alt="夜勤病栋 - 深夜病房"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="夜勤病栋 - 深夜病房的恐怖真相"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-50"></div>
      <div className="absolute inset-0 bg-primary-950/10"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/25 mb-6">
          <i className="ri-ghost-line text-primary-400 text-sm"></i>
          <span className="text-xs font-medium text-primary-300 whitespace-nowrap">经典恐怖作品深度解析</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-foreground-50 leading-tight mb-5">
          夜勤病栋
        </h1>
        <p className="text-lg md:text-xl text-foreground-200/80 mb-3 max-w-2xl mx-auto leading-relaxed">
          深夜病房的恐怖真相全解析
        </p>
        <p className="text-sm md:text-base text-foreground-400 max-w-xl mx-auto leading-relaxed mb-8">
          一部让无数人彻夜难眠的经典恐怖作品。深度解析故事背景、恐怖情节、人物设定与文化影响，带你重新审视这部夜班护士题材的惊悚经典，探寻深夜病房背后的黑暗秘密。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/plot-analysis"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 font-medium rounded-md transition-colors whitespace-nowrap"
          >
            <i className="ri-file-search-line"></i>
            开始探索
          </Link>
          <Link
            to="/category/viewing-guide"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-100/80 hover:bg-background-200 text-foreground-200 font-medium rounded-md border border-background-300/40 transition-colors whitespace-nowrap"
          >
            <i className="ri-guide-line"></i>
            观看指南
          </Link>
        </div>
      </div>
    </section>
  );
}